import { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";

export const ReactRouterLinkWrapper = forwardRef<
  HTMLAnchorElement,
  Omit<LinkProps, "to"> & { href: string }
>((props, ref) => {
  return <Link {...props} ref={ref} to={props.href} />;
});

ReactRouterLinkWrapper.displayName = "ReactRouterLinkWrapper";
